// extracted by mini-css-extract-plugin
module.exports = {"appStoreBadge":"accountCreated_appStoreBadge__LbiBs","playStoreBadge":"accountCreated_playStoreBadge__8rdUu"};